module.exports = __webpack_public_path__ + "img/completed-action-plan.e84e91ec.png";